import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.css']
})
export class DateRangePickerComponent implements OnInit {
  @Output() valueChange = new EventEmitter();
  @Input() key;
  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  fromDateStr
  toDateStr

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
    // Start empty so the first calendar click is captured as the range start.
    // Pre-seeding fromDate (without fromDateStr) made a first click on a future
    // date jump to the "set toDate" branch, emitting a period with no fromDate.
    this.fromDate = null;
    //this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  onDateSelection(date: NgbDate) {

    if (!this.fromDate && !this.toDate) {
      this.fromDateStr = this.toUtcDate(date)

      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDateStr = this.toUtcDate(date)
      this.toDate = date;
    } else {
      this.toDate = null;
      this.toDateStr = null
      this.fromDate = date;
      this.fromDateStr = this.toUtcDate(date)
    }
    this.emitValue();
  }

  // Typing into the from/to inputs used to update only the NgbDate display
  // models, never the emitted fromDateStr/toDateStr — so the dialog validated
  // a period that didn't match the dates the user could see. Keep the emitted
  // value in sync with whatever the inputs show.
  onFromInput(text: string) {
    this.fromDate = this.validateInput(this.fromDate, text);
    this.fromDateStr = this.fromDate ? this.toUtcDate(this.fromDate) : null;
    this.emitValue();
  }

  onToInput(text: string) {
    this.toDate = this.validateInput(this.toDate, text);
    this.toDateStr = this.toDate ? this.toUtcDate(this.toDate) : null;
    this.emitValue();
  }

  private toUtcDate(date: NgbDate): Date {
    return new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0, 0));
  }

  private emitValue() {
    this.valueChange.emit({ fromDate: this.fromDateStr, toDate: this.toDateStr, key: this.key });
  }
  ngOnInit(): void {

  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
}
